<div class="homepage-content p-0 m-0">
  <div class="container p-0 center">
    <div class="row py-2 m-0">
      <div class="col-md-12 text-center">
        <!-- <div #map style="width:100%;height:400px"></div> -->
        <!-- <div id="mapid"></div> -->
        <div class="col-12">
          <a class="btn btn-img-no-effect border-0" [routerLink]="['/homepage']"
            ><img
              src="../../../assets/images/logo-text.png"
              class="img-fluid homepage-logo"
              alt="Logo Image"
          /></a>
        </div>
        <div class="col-12 mt-1 mb-5">
          <h4 class="fw-600">
            Where Real People Shape Real Conversations -- No Anonymous Accounts
            Allowed To Comment!
          </h4>
        </div>
        <form class="col-md-6 p-0 mx-auto my-4">
          <div
            class="col-12 mx-auto px-2 d-flex homepage-search homepage-search-custom"
          >
            <!-- <div class="ng-autocomplete">
              <ng-autocomplete
                [data]="searchSuggetionList"
                name="searchValue"
                [initialValue]="searchValue"
                [searchKeyword]="'tagName'"
                (selected)="selectEvent($event)"
                (inputChanged)="onChangeSearch($event)"
                [itemTemplate]="autocompleteTemplate"
                placeholder="Search an Individual..."
                (keydown.enter)="onEnter($event)"
                #searchString
                id="homeInput"
              >
              </ng-autocomplete>
              <ng-template #autocompleteTemplate let-item>
                <h4
                  *ngIf="recentFirst"
                  class="recent font-16 text-left px-3 py-2 fw-600"
                >
                  Recent
                </h4>
                <a [innerHTML]="item.displayName" class="px-3"></a>
              </ng-template>
            </div> -->
            <div class="search-container">
              <input type="text" id="homeInput" class="form-control" placeholder="Search an Individual..." [(ngModel)]="searchValue"
                (input)="onChangeSearch(searchValue)" (keydown.enter)="onEnter($event)"  (focus)="onFocus()"
                (blur)="onBlur()" autocomplete="off"/>
            
              <div class="suggestions" *ngIf="showSuggestions && searchSuggetionList.length > 0">
                <!-- <h4 *ngIf="recentFirst" class="recent font-16 text-left px-3 py-2 fw-600">Recent</h4> -->
                <div *ngFor="let item of searchSuggetionList" (click)="selectEvent(item)" class="suggestion-item">
                  <span [innerHTML]="item.displayName"></span>
                </div>
              </div>
              </div>
            <button
              class="btn btn-secondary d-none"
              type="button"
              data-toggle="collapse"
              data-target="#collapseExample"
              aria-expanded="false"
              aria-controls="collapseExample"
            >
              <i class="fi flaticon-filter"></i>
            </button>
            <!-- <button type="submit" [disabled]="!searchValue" class="search-btn">
              <i class="fi flaticon-search"></i>
            </button> -->
          </div>
          <div
            class="collapse col-12 row mx-auto p-0 text-left filter-option"
            id="collapseExample"
          >
            <div class="col-12 col-sm-6 col-md-4 p-0 pr-sm-3">
              <ejs-multiselect
                [(value)]="selectedCategoryId"
                name="selectedCategoryId"
                id="selectedCategoryId"
                [dataSource]="categoryList"
                [fields]="{ text: 'name', value: 'id' }"
                [placeholder]="'Category'"
                (change)="getSubcategories()"
                (removing)="deleteCategory($event)"
                [changeOnBlur]="false"
                #categoryId
              >
                <ng-template #itemTemplate let-data>
                  <div class="row p-0 m-0 w-80">
                    <div class="p-0 m-0">
                      <img
                        [src]="data.iconPath"
                        class="fix-avtar-2-5 p-1"
                        alt=""
                        onerror="this.src='../../../assets/images/noprofile2.png';"
                      />
                    </div>
                    <div class="col p-0 m-0 text-truncate">{{ data.name }}</div>
                  </div>
                </ng-template>
              </ejs-multiselect>
            </div>
            <div class="col-12 col-sm-6 col-md-4 p-0">
              <ejs-multiselect
                [(value)]="selectedSubcategoryId"
                name="selectedSubcategoryId"
                id="selectedSubcategoryId"
                [dataSource]="subcategoryListForDataSource"
                [fields]="{
                  groupBy: 'categoryName',
                  text: 'name',
                  value: 'subCategoryId'
                }"
                mode="CheckBox"
                placeholder="Subcategory"
                (removing)="deleteSubCategory($event)"
                #subcategoryId
              ></ejs-multiselect>
            </div>
          </div>
        </form>
        <!-- Search Form Ends -->

        <div *ngIf="search && !notFound" class="col-12 col-md-6 p-0 m-auto">
          <ul class="profile-list h-100 row m-0">
            <li *ngFor="let profile of profileList" class="col-12 px-2 px-md-4">
              <button
                [routerLink]="['/profile/view-profile', profile.profileId]"
                class="w-100 px-2 py-3 row align-items-center btn-list"
              >
                <div class="col-auto px-2">
                  <img
                    *ngIf="!profile.profileImage"
                    src="../../../assets/images/noprofile2.png"
                    alt="Image"
                    class="fix-avtar-3 rounded border-img-shadow"
                  />
                  <img
                    *ngIf="!!profile.profileImage"
                    [src]="profile.profileImage"
                    onerror="this.src='../../../assets/images/noprofile2.png';"
                    class="fix-avtar-3 rounded border-img-shadow"
                  />
                </div>
                <div class="col text-left">
                  <p class="font-14 fw-600">{{ profile.profileName }}</p>
                  <p
                    *ngFor="let category of profile.categories"
                    class="font-12"
                  >
                    {{ category.name }}
                    <span *ngFor="let subcategory of category.subCategories"
                      >,{{ subcategory.name }}&nbsp;</span
                    >
                  </p>
                </div>
              </button>
            </li>
            <!-- li -->
          </ul>
          <!-- ul -->
        </div>

        <!-- .col -->
        <!-- <h3 *ngIf="trendingReviewList !== null" class="px-2 mx-1">Featured Reviews</h3> -->
        <!-- <h3 class="px-2 mx-1">Featured Reviews</h3> -->
        <!-- <ul class="nav nav-tabs review-nav">
          <li class="nav-item">
            <button class="nav-link" [ngClass]="{ active: trendingReviewActive == 'ALL' }" (click)="getTrendingReviews()">Feature Review</button>
          </li>
          <li class="nav-item">
            <button class="nav-link" [ngClass]="{ active: trendingReviewActive == 'STATE' }" (click)="getTrendingReviewsByLevel('STATE')">Trending Review</button>
          </li>
          </ul> -->
        <!-- <div *ngIf="!search && !notFound" class="col-12 mx-auto p-0 trending-reviews mt-3 text-left py-2">
          <div class="row mx-0 px-2">
            <ul class="nav nav-tabs review-nav">
              <li class="nav-item">
                <button class="nav-link" [ngClass]="{ active: trendingReviewActive == 'ALL' }" (click)="getTrendingReviews()">ALL</button>
              </li>
              <li class="nav-item">
                <button class="nav-link" [ngClass]="{ active: trendingReviewActive == 'LOCAL' }" (click)="getTrendingReviewsByLevel('LOCAL')">LOCAL</button>
              </li>
              <li class="nav-item">
                <button class="nav-link" [ngClass]="{ active: trendingReviewActive == 'STATE' }" (click)="getTrendingReviewsByLevel('STATE')">STATE</button>
              </li>
              <li class="nav-item">
                <button class="nav-link" [ngClass]="{ active: trendingReviewActive == 'NATIONAL' }" (click)="getTrendingReviewsByLevel('NATIONAL')">NATIONAL</button>
              </li>
            </ul>
          </div>
          <div class="row mt-3 px-1 d-flex mx-0" id="reviewDiv">
            <h3 *ngIf="trendingReviewList === null" class="col-12 text-center mt-3">&nbsp; Featured reviews will appear here, No featured reviews a the moment.</h3>
            <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12 px-2 py-2" *ngFor="let review of trendingReviewList">
              <a class="btn btn-card tranding-review p-3 w-100 h-100 position-relative br-10" [routerLink]="['/profile/view-response/', review.id]">
                <div class="loading br-10" [hidden]="trendingReviewLoading"></div>
                <div class="row">
                  <div class="col-auto pr-2 mb-1">
                    <a [routerLink]="['/profile/view-profile/', review.byProfileTagName]" (click)="$event.stopPropagation()" class="btn btn-img-rounded fix-avtar-4">
                      <img *ngIf="review.byProfileImage == ''" src="../../../assets/images/noprofile2.png" alt="Profile Image" />
                      <img *ngIf="review.byProfileImage != ''" [src]="review.byProfileImage" alt="Page Image" />
                    </a>
                  </div>
                  <div class="col pl-0 mb-1 text-left">
                    <a class="btn btn-link btn-link-theme p-0 text-left" [routerLink]="['/profile/view-profile', review.byProfileTagName]" (click)="$event.stopPropagation()">
                      <h6 class="bold text-theme">
                        {{ review.byProfileName }}
                        <p class="font-12 font-dark-gray">@{{ review.byProfileTagName }}</p>
                        <i class="fi flaticon-success font-14"></i>
                      </h6>
                    </a>
                  </div>
                </div>
                <div class="text-left review-text">
                  <a [routerLink]="['/profile/view-profile/', review.onProfileTagName]" class="font-12 font-dark-gray">@{{ review.onProfileTagName }}</a>
                  <p class="font-12 font-gray">
                    <span [innerHTML]="review.content | shorten: 65 | applinkifyHtml"></span>
                    <span *ngIf="review.content.length > 65">
                      ...
                      <button class="btn btn-link btn-link-theme read-more">Read More 123</button>
                    </span>
                  </p>
                </div>
              </a>
            </div>
          </div>
        </div> -->
        <!-- .trending-reviews -->
        <!-- <div class="row mx-md-auto mx-sm-3 mx-0 mt-3 flex-lg-row fix-height-240px flex-md-column-reverse flex-column-reverse" *ngIf="notFound && search && searchValue !== null">
          <div class="m-auto text-center position-relative">
            <h1>Sorry, we couldn't find any matching profile</h1>
          </div>
        </div> -->
      </div>
    </div>
    <!-- .row -->
    <div class="row mx-0">
      <div class="col-12 px-0">
        <app-representative-search></app-representative-search>
      </div>
    </div>
  </div>
  <!-- .container -->
</div>
<!-- .homepage-content -->
 <!-- have feedback modal  -->
<div class="modal fade havefeedbackmodal" tabindex="-1" role="dialog" id="haveFeedbacks" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog modal-dialog-custom modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-20 fw-600">Have Feedback?</h5>
        <button type="button" class="close" aria-label="Close" data-dismiss="modal"
          (click)="resetFormData(feedbackForm)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

        <form #feedbackForm="ngForm" (ngSubmit)="sendBugReportOrFeedback(feedbackForm)" novalidate>
          <div class="form-group d-flex aling-items-center radio-btn-group">
            <label class="d-flex align-items-center font-18 fw-600 mb-0">Report a bug
              <input type="radio" name="feedback" value="report a bug" [(ngModel)]="reportBugFeedbackDTO.type"
                class="ml-3" required #type="ngModel" /></label>
            <label class="d-flex align-items-center font-18 fw-600 mb-0">Feedback
              <input type="radio" name="feedback" value="feedback" [(ngModel)]="reportBugFeedbackDTO.type" class="ml-3"
                required #type="ngModel" />
            </label>
          </div>
          <div *ngIf="feedbackForm.submitted && type.invalid" class="text-danger mb-2 text-center">
            Please select a feedback type.
          </div>
          <div class="form-group">
            <label for="description" class="font-16 fw-600">Description</label>
            <textarea id="description" class="form-control" rows="5" [(ngModel)]="reportBugFeedbackDTO.description"
              name="description" required maxlength="1000" #description="ngModel" NoLeadingWhitespace></textarea>
            <div *ngIf="feedbackForm.submitted && description.invalid" class="text-danger">
              <span *ngIf="description.errors?.['required']">Description is required.</span>
              <span *ngIf="description.errors?.['maxlength']">You've reached the maximum limit of 1000
                characters.</span>
            </div>
          </div>
          <div class="d-flex justify-content-end mr-4">
            <button type="button" class="btn btn-outline-black mt-4 pt-2 mb-3 mx-2 font-16 fw-600" data-dismiss="modal"
              (click)="resetFormData(feedbackForm)">
              Cancel
            </button>
            <button type="submit" class="btn btn-black mt-4 pt-2 mb-3 mx-2 font-16 fw-600">
              Report
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<!-- have feedback modal  -->